//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import divSpan from '@/components/DivSpan';
export default {
  name: "erp-price-detail",
  components:{divSpan},
  data(){
    return{
      priceId:null,
      erpPriceDto:{},
      tabIndex:1
    }
  },
  methods:{
    back(){
      this.$router.go(-1);
    },
    getErpPriceDetail(){
      this.$loadingShow()
      this.$get(`api/priceMasterData/${this.priceId}`).then((data) => {
        this.$loadingHide()
        if(data){
          this.erpPriceDto = data;
        }
      }).catch(err=>this.$loadingHide())
    },
    changeView(index){
      this.tabIndex = index;
    }
  },
  mounted(){
    this.priceId = this.$route.params.priceId;
    this.getErpPriceDetail();
  }
}



// WEBPACK FOOTER //
// ./src/page/price-library/erp-price-detail.vue